import { render } from "./svgSprite.vue?vue&type=template&id=06995254"
import script from "./svgSprite.vue?vue&type=script&lang=js"
export * from "./svgSprite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__